module.exports = __webpack_public_path__ + "assets/img/sabc_social_twitter.webp?404328bc927af6f2239f24369de0b9c0";